import React, { useEffect, useState } from 'react';
import SectionLabel from '../components/SectionLabel';
import PropertyCard from '../components/PropertyCard';
import { useLang } from '../context/LanguageContext';
import { fetchProperties } from '../lib/api';

export default function Listing({ title, filter }) {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchProperties(filter ? { status: filter } : {})
      .then((data) => setItems(data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="px-6 md:px-12 lg:px-16 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel>{title}</SectionLabel>
        <h1 className="mt-6 text-4xl md:text-5xl font-light tracking-tight">{title}</h1>
        <div className="mt-12">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="aspect-[4/3] bg-neutral-100 animate-pulse" />
              ))}
            </div>
          ) : items.length === 0 ? (
            <p className="text-neutral-500 py-16 text-center">{t.listing.empty}</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {items.map((p) => (
                <PropertyCard key={p.slug} property={p} t={t} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
